<div class="flex flex-col gap-3 p-3">
  <ag1-title [label]="title" />
  <ag-shimmer-loader />
</div>
